// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import chevronRight from "./assets/chevron-right.svg";
var CARE_COMMON_ASSETS_MAP = {
  CHEVRON_RIGHT: chevronRight
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CARE_COMMON_ASSETS_MAP);
};

// src/components/care-page-wrapper/care-page-wrapper.component.tsx
import * as React from "react";
import { Box, Flex, HeadingOne } from "@leagueplatform/genesis-commons";
import { LinkLegacy as Link } from "@leagueplatform/routing";
import { getScopedCssClassnames } from "@leagueplatform/ui-kit";
import {
  BackButtonArrow,
  PageHeaderBackground
} from "@leagueplatform/web-common-components";
function CarePageWrapper({
  backButtonPath,
  backButtonOnClick,
  children,
  title
}) {
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      className: getScopedCssClassnames(),
      maxWidth: "1272px",
      width: "100%",
      padding: { _: "oneAndHalf", phone: "two" },
      marginX: "auto",
      justifyContent: "center"
    },
    title && /* @__PURE__ */ React.createElement(PageHeaderBackground, null),
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        flexDirection: { _: "column", phone: "row" },
        width: "100%",
        alignItems: "flex-start"
      },
      (backButtonPath || backButtonOnClick) && /* @__PURE__ */ React.createElement(
        BackButtonArrow,
        {
          as: Link,
          to: backButtonPath,
          marginTop: "threeQuarters",
          marginInlineStart: "none",
          marginInlineEnd: "two",
          onClick: backButtonOnClick
        }
      ),
      /* @__PURE__ */ React.createElement(Box, { width: "100%" }, title && /* @__PURE__ */ React.createElement(
        HeadingOne,
        {
          marginTop: "half",
          marginBottom: "five",
          fontSize: { _: "heading2", phone: "heading1" }
        },
        title
      ), children)
    )
  );
}

// src/index.tsx
initModule();
export {
  CarePageWrapper
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/care-common'] = window.leagueSDKsPresent['@leagueplatform/care-common'] || [];
    window.leagueSDKsPresent['@leagueplatform/care-common'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/care-common'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/care-common module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map